import React from 'react';
import {observer} from 'mobx-react';
import ModelValue from 'shared/components/tables/components/ModelValue';
import {getColumnClasses, getColumnStyle} from 'shared/components/tables/interactive/components/accordion_table/utils';
import DocumentFoldersIcon from 'img/settings/settings-folders@2x.png';

const Chevron = observer(({viewModel}) => {
  return <i className={`mr1 material-icons jumbo row-chevron ${viewModel.isExpanded ? 'expanded' : ''}`}>chevron_right</i>;
});

const FolderIcon = () => {
  return <img src={DocumentFoldersIcon} className='mr1' height='16' width='16' alt='folder'/>;
};

const AccordionTableCell = observer(({
  column,
  viewModel,
  level,
  canExpandRow,
  isFirstColumn,
  horizontalScroll,
  ...rest
}) => {
  let paddingLeft = 0;
  if (isFirstColumn && level > 0) {
    paddingLeft = 32 + (25 * (level - 1));
  }
  if (isFirstColumn && !canExpandRow) {
    paddingLeft += 32;
  }

  const columnStyle = getColumnStyle(column, horizontalScroll);
  const style = paddingLeft ? {...columnStyle, paddingLeft} : columnStyle;

  return (
    <div
      className={`AccordionTableCell flex align-items-middle ${getColumnClasses(column, horizontalScroll)} ${column.className || ''}`}
      style={style}
    >
      {isFirstColumn && canExpandRow && <Chevron viewModel={viewModel}/>}
      {viewModel.isFolder && <FolderIcon/>}
      <ModelValue
        model={viewModel.data}
        column={column}
        level={level}
        parent={viewModel.parent}
        {...rest}
      />
    </div>
  );
});

export default AccordionTableCell;
